import { render } from "./KeywordSuggestions.vue?vue&type=template&id=016e47b8"
import script from "./KeywordSuggestions.vue?vue&type=script&lang=js"
export * from "./KeywordSuggestions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__